const getParentUrl = () => {
  const url =
    window.location !== window.parent.location
      ? document.referrer
      : document.location.href;
  return url;
};

export const sendHeartbeatEvent = (actions, mode) => {
  console.info("analyticsutil sendHeartbeatEvent");
  actions.Tracker.sendAnalyticsEvent(
    "Timing",
    {
      action: "Heartbeat",
    },
    { nonInteraction: false },
    {
      mode,
      referrer: getParentUrl(),
    }
  );
};

export const sendPageLoadEvent = (actions, mode) => {
  console.info("analyticsutil sendPageLoadEvent ", mode);
  actions.Tracker.sendAnalyticsEvent(
    "Page",
    {
      action: `Initial Page Load with ar = ${mode}`,
    },
    { nonInteraction: true },
    {
      mode,
      referrer: getParentUrl(),
    }
  );
};

export const sendAutoEvent = (actions, mode, eventAction, nonInteraction) => {
  console.info("analyticsutil sendAutoEvent ", eventAction);
  actions.Tracker.sendAnalyticsEvent(
    mode,
    { action: eventAction },
    { nonInteraction },
    {
      mode,
      referrer: getParentUrl(),
    }
  );
};

export const sendButtonClickEvent = (
  actions,
  mode,
  eventAction,
  nonInteraction,
  label
) => {
  console.info("analyticsutil sendButtonClickEvent");
  actions.Tracker.sendAnalyticsEvent(
    mode,
    { action: eventAction },
    { nonInteraction },
    {
      mode,
      referrer: label,
    }
  );
};

export const sendModeSwitchEvent = (actions, mode, label) => {
  console.info("analyticsutil sendModeSwitchEvent ok");
  actions.Tracker.sendAnalyticsEvent(
    mode,
    { action: "onClick Button" },
    { nonInteraction: true },
    {
      mode,
      referrer: label,
    }
  );
};

export const sendPageClickEvent = (actions, mode) => {
  console.info("analyticsutil sendPageClickEvent");
  actions.Tracker.sendAnalyticsEvent(
    "Page",
    {
      action: "Clicked",
    },
    {
      nonInteraction: false,
    },
    {
      mode,
      referrer: getParentUrl(),
    }
  );
};
